export const RESET = 'RESET'
export const SET_USERDATA_ITEMS = 'USERDATA_LIST_SET_ITEMS'
export const SET_ITEMTYPES_ITEMS = 'ITEMTYPES_LIST_SET_ITEMS'
export const SET_ITEMBRANDS_ITEMS = 'ITEMBRANDS_LIST_SET_ITEMS'
export const SET_ITEMCATEGORIES_ITEMS = 'ITEMCATEGORIES_LIST_SET_ITEMS'
export const SET_PRICEGROUPS_ITEMS = 'PRICEGROUPS_LIST_SET_ITEMS'
export const SET_MEASURES_ITEMS = 'MEASURES_LIST_SET_ITEMS'
export const SET_VATRATES_ITEMS = 'VATRATES_LIST_SET_ITEMS'
export const SET_CASES_ITEMS = 'CASES_LIST_SET_ITEMS'
export const TOGGLE_LOADING = 'USERDATA_LIST_TOGGLE_LOADING'
